import React from 'react';
import classNames from 'classnames';
import s from './style.scss';
const BrandCard = ({ style, active, url, onClick }) => {
    return (React.createElement("div", { className: classNames(style, s.brandCard, { [s.activeCard]: active }), onClick: onClick },
        React.createElement("img", { className: s.brandLogo, src: url })));
};
export default BrandCard;
